export default "__VITE_ASSET__CbLWBR3R__"